import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxntInlineSpinnerComponent } from './rxnt-inline-spinner.component';

@NgModule({
  declarations: [
    RxntInlineSpinnerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RxntInlineSpinnerComponent,
  ],
})
export class RxntInlineSpinnerModule {
}
